// src/screens/Modals/ReferralRewardModal.tsx

import React, { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import '@/screens/Modals/ReferralRewardModal.css'
import { Award } from 'lucide-react'

interface ReferralRewardModalProps {
  isOpen: boolean
  onClose: () => void
  rewards: {
    referrerReward?: number
    refereeReward?: number
    milestone?: {
      count: number
      reward: number
    }
  }
}

export const ReferralRewardModal: React.FC<ReferralRewardModalProps> = ({
  isOpen,
  onClose,
  rewards,
}) => {
  const [currentStep, setCurrentStep] = useState<
    'initial' | 'milestone' | 'complete'
  >('initial')

  useEffect(() => {
    if (!isOpen) {
      setCurrentStep('initial')
    }
  }, [isOpen])

  if (!isOpen) return null

  return (
    <div className="reward-modal-overlay" onClick={onClose}>
      <div
        className="reward-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <AnimatePresence mode="wait">
          {currentStep === 'initial' && (
            <motion.div
              className="reward-content"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.8 }}
              key="initial"
            >
              <div className="reward-header">
                <h2>Rewards Earned!</h2>
                {rewards.referrerReward ? (
                  <p>You earned rewards for referring a friend</p>
                ) : (
                  <p>Welcome bonus from using a referral code</p>
                )}
              </div>

              <div className="token-reward-animation">
                <div className="token-circle">
                  <span className="token-amount">
                    +{rewards.referrerReward || rewards.refereeReward}
                  </span>
                  <span className="token-label">CARD tokens</span>
                </div>
              </div>

              {rewards.milestone ? (
                <button
                  className="reward-continue"
                  onClick={() => setCurrentStep('milestone')}
                >
                  More Rewards Available!
                </button>
              ) : (
                <button className="reward-close" onClick={onClose}>
                  Awesome!
                </button>
              )}
            </motion.div>
          )}

          {currentStep === 'milestone' && rewards.milestone && (
            <motion.div
              className="reward-content"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.8 }}
              key="milestone"
            >
              <div className="milestone-header">
                <Award size={48} />
                <h2>Milestone Achieved!</h2>
                <p>{rewards.milestone.count} Successful Referrals</p>
              </div>

              <div className="milestone-reward-animation">
                <div className="milestone-circle">
                  <span className="token-amount">
                    +{rewards.milestone.reward}
                  </span>
                  <span className="token-label">Bonus Tokens</span>
                </div>
              </div>

              <button className="reward-close" onClick={onClose}>
                Claim Rewards
              </button>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  )
}
